import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { BoardConfig, resolveBoardConfig } from '../depatureboard/board-config';

const dualDefaults = {
  panel1: {
    busstop: 'busstation',
    showstand: 'true',
    showstopname: 'true',
    direction: 'south',
    theme: 'dark'
  },
  panel2: {
    busstop: 'busstation',
    showstand: 'true',
    showstopname: 'true',
    direction: 'north',
    theme: 'light'
  }
};

@Component({
  selector: 'app-dual-board',
  templateUrl: './dual-board.component.html',
  styleUrls: ['./dual-board.component.css']
})
export class DualBoardComponent implements OnInit, OnDestroy {
  config1: BoardConfig = resolveBoardConfig({}, '1', dualDefaults.panel1);
  config2: BoardConfig = resolveBoardConfig({}, '2', dualDefaults.panel2);

  private queryParamsSubscription?: Subscription;

  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.queryParamsSubscription = this.route.queryParams.subscribe((params) => {
      this.config1 = resolveBoardConfig(params, '1', dualDefaults.panel1);
      this.config2 = resolveBoardConfig(params, '2', dualDefaults.panel2);
    });
  }

  ngOnDestroy(): void {
    this.queryParamsSubscription?.unsubscribe();
  }
}
